import React from "react";
import Lightbox from "react-images";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import styles from './gallery.module.css';

export default class Gallery extends React.Component {
    constructor() {
        super();
        this.state = {
            isOpen: false,
            current: 0
        };
        this.images = [];
        this.closeLightbox = this.closeLightbox.bind(this);
        this.goToNext = this.goToNext.bind(this);
        this.goToPrevious = this.goToPrevious.bind(this);
        this.loadImages = this.loadImages.bind(this);
    }

    loadImages(data) {
        this.images = data.allFile.edges
            .filter(edge => !edge.node.name.endsWith('.thumb'))
            .sort((a, b) => a.node.name.localeCompare(b.node.name))
            .map(edge => ({
                "src": require("../images/galleries/" + edge.node.relativePath),
                "thumbnail": require("../images/galleries/" + edge.node.relativePath.replace(".jpg", ".thumb.jpg"))
            }));
    }

    closeLightbox() {
        this.setState({
            isOpen: false,
            current: 0
        });
    }

    goToNext() {
        this.setState({
            current: this.state.current + 1
        });
    }

    goToPrevious() {
        this.setState({
            current: this.state.current - 1
        });
    }

    render() {
        return <Container fluid>
            {this.loadImages(this.props.data)}
            <Row style={{ textAlign: "center" }}>
                {this.images
                    .map(item =>
                        <Col md={3} xs={4}>
                            <a href="#"
                                onClick={() => this.setState({
                                    isOpen: true,
                                    current: this.images.indexOf(item)
                                })}>
                                <Image
                                    className={styles.thumb}
                                    src={item.thumbnail}
                                    rounded />
                            </a>
                        </Col>)}

            </Row>
            <Lightbox
                images={this.images}
                onClickPrev={this.goToPrevious}
                onClickNext={this.goToNext}
                isOpen={this.state.isOpen}
                onClose={this.closeLightbox}
                currentImage={this.state.current}
                backdropClosesModal={true}
                imageCountSeparator={"/"}
                theme={{
                    image: {
                        boxShadow: "6px 6px 8px black"
                    }
                }}
            />
        </Container>
    }

}